export function getSingleAttributeValue<T>(obj: Record<string, T>): T | any {
    const keys = Object.keys(obj);

    if (keys.length === 1) {
        return obj[keys[0]];
    }

    // Optionally, you could throw an error or return `undefined`
    // if there are not exactly one property in the object.
    console.error("Object does not have exactly one attribute.");
    return obj;
}
